// Constants
import {
  CONTACT_PAGE_URL,
  HOME_PAGE_URL,
  CARPENTRY_PAGE_URL,
  BATHROOMS_PAGE_URL,
  GROUNDWORKS_PAGE_URL,
  BUILDING_WORK_PAGE_URL,
} from '../Constants';

export const FooterLinksArray = [
  {
    name: 'Home',
    route: HOME_PAGE_URL,
  },
  {
    name: 'Carpentry',
    route: CARPENTRY_PAGE_URL,
  },
  {
    name: 'Bathrooms',
    route: BATHROOMS_PAGE_URL,
  },
  {
    name: 'Groundworks',
    route: GROUNDWORKS_PAGE_URL,
  },
  {
    name: 'Building Work',
    route: BUILDING_WORK_PAGE_URL,
  },
  {
    name: 'Contact',
    route: CONTACT_PAGE_URL,
  },
];
